import Spacer from "components/Spacer"
import { cdn } from "core/cdn"

import { GenericModal } from "./Modal"
import { useLanguage } from "locales"
import DOMPurify from "dompurify";

export const ContraceptionModal = ({ open, onAccept }: { open: boolean, onAccept: () => void }) => {
  const { languages } = useLanguage()
  return (
    <GenericModal
      visible={open}
      onAccept={onAccept}
      acceptText={languages.IGotIt}
      acceptButtonProps={{style:{backgroundColor: "#1d71b8", borderColor: "#1d71b8"}}}
      style={{ width: "70vw"}}
    >
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '66px', padding: "35px"}}>
        <div><img src={cdn("/images/picto_warning.svg")} width={'100px'} alt="Attention"/></div>
        <Spacer
          style={{ textAlign: "center", maxWidth: "70vw", padding: "0 70px" }}
          size={30}
          align="start"
          direction="vertical">
        <span style={{ fontWeight: "500", fontSize: "28px" }} dangerouslySetInnerHTML={{
            __html: (DOMPurify.sanitize(languages.contraceptionModalNotSuitable_html))
          }} />
        <div className="flex-center" style={{ gap: "26px", alignItems: "center" }}>
          <img src={cdn("images/clear_red.svg")} alt="clear"  style={{ width: '42px', height: '42px'  }}/>
          <span style={{ fontWeight: "500", fontSize: "28px" }} dangerouslySetInnerHTML={{
            __html: (DOMPurify.sanitize(languages.contraceptionModalNotSuitableReason1_html))
          }} />
        </div>
        <div className="flex-center" style={{ gap: "26px", alignItems: "center" }}>
          <img src={cdn("images/clear_red.svg")} alt="clear"  style={{ width: '42px', height: '42px'}}/>
          <span style={{ fontWeight: "500", fontSize: "28px" }} >{languages.contraceptionModalNotSuitableReason2}</span>  
        </div>
        </Spacer>
      </div>
    </GenericModal>
  )
}

